export default __webpack_public_path__ + "static/media/userdata.f31b4fbe.svg";